import { useSelector } from 'src/hooks/useSelector';

interface UseResumesCount {
    countResumes: number;
    visibleResumesCount: number;
    canConnect: boolean;
}

const useResumesCount = (): UseResumesCount => {
    const targetResumesCount = useSelector((state) => state.employerInfo.targetResumesCount);
    const resumesInfo = useSelector((state) => state.applicantInfo);
    const visibleResumesCount = resumesInfo.visible;
    let countResumes = targetResumesCount;
    if (countResumes > visibleResumesCount) {
        // если у пользователя есть скрытые резюме
        countResumes = visibleResumesCount;
    }

    const canConnect = !countResumes && (visibleResumesCount !== countResumes || visibleResumesCount === 0);

    return { countResumes, visibleResumesCount, canConnect };
};

export { useResumesCount };
